import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'

@Module({
  name: 'IcTagStore',
  namespaced: true,
  stateFactory: true
})
export default class IcTagStore extends BaseStore {
  _processing: boolean = false

  get processing(): boolean {
    return this._processing
  }

  @Mutation
  public startProcess(): void {
    this._processing = true
  }

  @Mutation
  public endProcess(): void {
    this._processing = false
  }
}
